<template>
  <div id="app">
    <div v-if="content">
      <header>
        <div
          v-if="content.logo"
          class="logo"
          :style="{ 
          backgroundImage: `url('${content.logo.data.full_url}')`
          }"
        ></div>
      </header>

      <text-module :content="content"></text-module>
      <image-module :content="content"></image-module>
      <video-module
        :content="content"
        :current-video="currentPlayingVideo"
        @play="onVideoPlay"
        @pause="v => onVideoPause(v)"
      ></video-module>

      <slider-module :content="content"></slider-module>
    </div>
    <div v-else-if="error" class="notfound">
      <span class="notfound__headline">404</span>
      <span class="notfound__copy">Page not found</span>
    </div>

    <div v-else>Loading...</div>
  </div>
</template>

<script>
import { VueAgile } from "vue-agile";
import ImageModule from "./components/ImageModule.vue";
import SliderModule from "./components/SliderModule.vue";
import TextModule from "./components/TextModule.vue";
import VideoModule from "./components/VideoModule.vue";

export default {
  name: "app",
  components: {
    agile: VueAgile,
    ImageModule,
    SliderModule,
    TextModule,
    VideoModule
  },
  data() {
    return {
      content: null,
      filesUrl: process.env.VUE_APP_FILES_URL,
      currentPlayingVideo: null,
      partnerId: null,
      error: null
    };
  },
  mounted() {
    this.partnerId = this.getPartnerId();

    this.getCMSContent().then(data => {
      this.content = data;
    });
  },
  methods: {
    getCMSContent() {
      return fetch(
        `${process.env.VUE_APP_API_URL}/partner?fields=*.*.*&filter[partner_id][eq]=${this.partnerId}&single=1`
      )
        .then(response => {
          if (!response.ok) {
            this.error = true;
            throw Error(response.statusText);
          }
          return response.json();
        })
        .then(({ data }) => {
          return data;
        })
        .catch(err => console.log(err));
    },

    getPartnerId() {
      var result = null,
        tmp = [];
      location.search
        .substr(1)
        .split("&")
        .forEach(function(item) {
          tmp = item.split("=");
          if (tmp[0] === "p") result = decodeURIComponent(tmp[1]);
        });
      return result;
    },

    onVideoPlay(videoEl) {
      this.currentPlayingVideo = videoEl;
    },

    onVideoPause(videoEl) {
      this.currentPlayingVideo = null;
    }
  }
};
</script>

<style lang="scss">
#app {
  display: block;
}
</style>
